import ZoomedGallery from './ZoomedGallery';

export default ZoomedGallery;
